export const saveToLocalStorageCart = (key, data) => {
    localStorage.setItem(key, JSON.stringify(data));
};

export const getFromLocalStorageCart = (key) => {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : [];
};



